// extracted by mini-css-extract-plugin
export default {"paymentForm":"payment-form_paymentForm__Vejad","paymentElement":"payment-form_paymentElement__uYQT7","payButton":"payment-form_payButton__u73vZ"};